import { render } from "./HeaderHelpCard.vue?vue&type=template&id=a502ba00"
import script from "./HeaderHelpCard.vue?vue&type=script&lang=js"
export * from "./HeaderHelpCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Downloads\\21TCG\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__